import React from 'react';
import { Box, Button } from '@mui/material';
import { NOTIFICATION_FILTERS, type NotificationFilterKey } from './notificationFormatters';
import { CWY_COLORS } from '../../theme/colors';

interface NotificationFiltersProps {
  active: NotificationFilterKey;
  onChange: (key: NotificationFilterKey) => void;
}

export const NotificationFilters: React.FC<NotificationFiltersProps> = ({ active, onChange }) => (
  <Box
    sx={{
      bgcolor: 'transparent',
      borderBottom: `1px solid ${CWY_COLORS.border}`,
    }}
  >
    <Box
      role="tablist"
      aria-label="Notification filters"
      sx={{
        display: 'flex',
        gap: 0.25,
        px: 2.5,
        overflowX: 'auto',
        scrollPaddingInline: 20,
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}
    >
      {NOTIFICATION_FILTERS.map((filter) => {
        const selected = active === filter.key;
        return (
          <Button
            key={filter.key}
            role="tab"
            aria-selected={selected}
            size="small"
            onClick={() => onChange(filter.key)}
            sx={{
              flexShrink: 0,
              textTransform: 'none',
              fontWeight: selected ? 600 : 500,
              fontSize: '0.875rem',
              borderRadius: 0,
              px: 1.25,
              py: 1.25,
              minHeight: 44,
              color: selected ? CWY_COLORS.teal : CWY_COLORS.textSecondary,
              bgcolor: 'transparent',
              borderBottom: '2px solid',
              borderColor: selected ? CWY_COLORS.teal : 'transparent',
              boxShadow: 'none',
              whiteSpace: 'nowrap',
              '&:hover': {
                bgcolor: 'rgba(0, 113, 133, 0.06)',
                color: selected ? CWY_COLORS.teal : CWY_COLORS.textPrimary,
                boxShadow: 'none',
              },
            }}
          >
            {filter.label}
          </Button>
        );
      })}
    </Box>
  </Box>
);
